import axios, { AxiosInstance, AxiosRequestConfig } from "axios";
// import { UserLogOut } from "./Fetch";
import { setIsLogin, setUser } from "Components/store/globalSlice";
import { useAppDispatch } from "store/hook";
import { store } from "store/store";
import https from "https";

// import { useLogout } from "Components/Login/quires";
const proxyIP = require("../../package.json");

// let httpCode = {
//   400: "请求参数错误",
//   401: "权限不足, 请重新登录",
//   403: "服务器拒绝本次访问",
//   404: "请求资源未找到",
//   500: "内部服务器错误",
//   501: "服务器不支持该请求中使用的方法",
//   502: "网关错误",
//   504: "网关超时",
// };

export function removePort(url:string) {
  return url.replace(/:\d+$/, '');
}

const { dispatch } = store;

//Axios setting config

const config: AxiosRequestConfig = {
  baseURL: "",
  // timeout: 10000,
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
};
//Create Axios
const service: AxiosInstance = axios.create(config);

// default: application/json
// service.defaults.headers.post["Content-Type"] = "application/json";

let csrfRefreshing = false;
let csrfRefreshPromise: Promise<void> | null = null;

// TODO:新增補足csrf 解決原始碼掃描Django安全問題 #250630
export const initCsrf = async () => {
  if (!csrfRefreshing) {
    csrfRefreshing = true;

    csrfRefreshPromise = fetch("/csrf", {
      method: "GET",
      credentials: "include",
    })
      .then(() => {
        // console.log("✅ CSRF 初始化成功");
      })
      .catch((err) => {
        // console.error("❌ CSRF 初始化失敗", err);
      })
      .finally(() => {
        csrfRefreshing = false;
        csrfRefreshPromise = null;
      });
  }

  return csrfRefreshPromise;
};

export function getCookie(name: string): string | null {
  const cookies = document.cookie.split(';');
  for (let cookie of cookies) {
    const [key, ...rest] = cookie.trim().split('=');
    if (key === name) {
      return decodeURIComponent(rest.join('='));
    }
  }
  return null;
}

// TODO:新增補足csrf 解決原始碼掃描Django安全問題 #250630
/** 添加请求拦截器 **/
service.interceptors.request.use(
  (config) => {
    const csrfToken = getCookie("csrftoken");
    if (csrfToken) {
      config.headers = config.headers || {};
      config.headers["X-CSRFToken"] = csrfToken;
    }
    // 確保跨域時能帶上 cookie（Django 需要這個）
    config.withCredentials = true;

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export function ensureCsrf() {
  const token = getCookie("csrftoken");
  if (token) {
    return Promise.resolve();
  }
  // 不等待結果，失敗也不阻塞
  return initCsrf().catch((e) => {
    console.warn("CSRF Initialization failed", e);
  });
}

// service.interceptors.request.use(
//   (config) => {
//     // const token = localStorage.getItem("authUser.token") || ''
//     // config.headers.common['Authorization'] = `Bearer ${token}`

//     // 在这里：可以根据业务需求可以在发送请求之前做些什么:例如我这个是导出文件的接口，因为返回的是二进制流，所以需要设置请求响应类型为blob，就可以在此处设置。
//     // if (config.url.includes('pur/contract/export')) {
//     //     config.headers['responseType'] = 'blob'
//     // }
//     // 我这里是文件上传，发送的是二进制流，所以需要设置请求头的'Content-Type'
//     // if (config.url.includes('pur/contract/upload')) {
//     //     config.headers['Content-Type'] = 'multipart/form-data'
//     // }
    
//     return config;
//   },
//   (error) => {
//     //     // 对请求错误做些什么
//     return Promise.reject(error);
//   }
// );

/** 添加响应拦截器  **/
// instance.interceptors.response.use(response => {

//     // if (response.statusText === 'ok') {     // 响应结果里的statusText: ok是我与后台的约定，大家可以根据实际情况去做对应的判断
//     //     return Promise.resolve(response.data)
//     // } else {
//     //     message.error('响应超时')
//     //     return Promise.reject(response.data.message)
//     // }
//     return Promise.resolve(response.data)
// }, error => {

//     if (error.response) {
//         // 根据请求失败的http状态码去给用户相应的提示
//         // let tips = error.response.status in httpCode ? httpCode[error.response.status] : error.response.data.message
//         // message.error(tips)
//         if (error.response.status === 401) {    // token或者登陆失效情况下跳转到登录页面，根据实际情况，在这里可以根据不同的响应错误结果，做对应的事。这里我以401判断为例
//             //针对框架跳转到登陆页面
//             console.log('interceptors 401')
//         }
//         return Promise.reject(error)
//     } else {
//         message.error('请求超时, 请刷新重试')
//         return Promise.reject('请求超时, 请刷新重试')
//     }
// })

// 響應攔截器
// export const useHttp = () => {

//   const disp = useAppDispatch();

//   service.interceptors.response.use(
//     (response) => {
//       //根據返回不同的狀態碼做不同的事情
//       // 這裡一定要和後臺開發人員協商好統一的錯誤狀態碼
//       return Promise.resolve(response);
//     },
//     ((error: any) => {

//       if (error.response?.status === 401) {
//         console.log(error)
//         disp(setIsLogin(false))
//         UserLogOut();
//         return Promise.reject(error);
//         // token或者登陆失效情况下跳转到登录页面，根据实际情况，在这里可以根据不同的响应错误结果，做对应的事。这里我以502判断为例
//       }
//       return Promise.reject(error);
//     })
//   );

//   return service;
// };



// 原本寫法 #250630
// service.interceptors.response.use(
//   (response) => {
//     //根據返回不同的狀態碼做不同的事情
//     // 這裡一定要和後臺開發人員協商好統一的錯誤狀態碼
//     return Promise.resolve(response);
//   },
//   (error: any) => {
//     // const { mutate: logoutMutation } = useLogout();
//     if ((error.response?.status === 401 && error.response?.data !== "login fail !") || error.response?.status === 403) {
//       dispatch(setIsLogin(false));
//       dispatch(setUser(undefined));
//       UserLogOut();
//       // logoutMutation();
//       return Promise.reject(error);
//       // token或者登陆失效情况下跳转到登录页面，根据实际情况，在这里可以根据不同的响应错误结果，做对应的事。这里我以502判断为例
//     }
//     return Promise.reject(error);
//   }
// );

// TODO:新增補足csrf 解決原始碼掃描Django安全問題 #250630
service.interceptors.response.use(
  (response) => response,
  async (error: any) => {
    const originalRequest = error.config;

    const isCsrfError =
      error.response?.status === 403 &&
      (typeof error.response?.data === "string" && error.response?.data.includes("CSRF"));

    if (isCsrfError && !originalRequest._retry) {
      originalRequest._retry = true;

      // ❗只呼叫一次 CSRF 初始化，其他請求等待
      await initCsrf();

      // 再次發送原本的請求
      return service(originalRequest);
    }

    // 處理登入失效
    if (
      (error.response?.status === 401 && error.response?.data !== "login fail !") ||
      error.response?.status === 403&& !isCsrfError
    ) {
      dispatch(setIsLogin(false));
      dispatch(setUser(undefined));
      UserLogOut();
    }

    return Promise.reject(error);
  }
);

const httpsAgent = new https.Agent({
  keepAlive: true, // 保持 TCP 連線，重複使用
});

// -----Open-API----
const configOpenAPI: AxiosRequestConfig = {
  baseURL: `${process.env.NODE_ENV === "development" ? `${removePort(proxyIP?.proxy)}:8001` :window?.OpenAPI_IP}/openapi`,
  // timeout: 10000,
  httpsAgent,
  headers: { "Content-Type": "application/json" },
  withCredentials: false,
};

//Create Open-API Axios
export const serviceOpenAPI: AxiosInstance = axios.create(configOpenAPI);

serviceOpenAPI.interceptors.request.use(
  (config) => {
 const openapiToken = localStorage.getItem("authUser.openapiToken");

  if (!openapiToken) {
    // 拒絕請求，前端呼叫的地方會收到 rejected promise，能 catch 到
    return Promise.reject(new Error("No API token available, request canceled."));
  }

  config.headers.Authorization = `Bearer ${openapiToken}`;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);


export default service;

const UserLogOut = async () => {
  const url = "/logout";
  let response;
  try {
    response = await fetch(url, { credentials: "include", method: "POST" });
    localStorage.removeItem("authUser.name");
    localStorage.removeItem("authUser.cid");
    localStorage.removeItem("authUser.level");
    localStorage.removeItem("authUser.openapiToken");
    return response;
  } catch (error) {
    console.log("error: ", error);
    response = error;
    return response;
  }
};
